const _excluded = ["style", "children", "shouldWrapChildren", "wrapper"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import { stylePropType } from '@adsk/alloy-react-theme';
const TargetWrapped = (_ref, ref) => {
  let {
      style,
      children,
      shouldWrapChildren = true,
      wrapper: Wrapper
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const isNodeElement = obj => !!obj && obj.hasOwnProperty('props');
  const shouldWrap = !isNodeElement(children) || shouldWrapChildren;
  if (!shouldWrap) {
    const childNode = React.Children.only(children);
    return isNodeElement(childNode) ? /*#__PURE__*/React.cloneElement(childNode, _objectSpread({
      ref
    }, props)) : null;
  }
  return /*#__PURE__*/React.createElement(Wrapper || 'div', _objectSpread({
    ref,
    style
  }, props), children);
};
const Target = /*#__PURE__*/React.forwardRef(TargetWrapped);
Target.displayName = 'Target';
Target.propTypes = {
  /** className */
  className: PropTypes.string,
  /** style */
  style: stylePropType,
  /** children */
  children: PropTypes.any,
  /** should wrap */
  shouldWrapChildren: PropTypes.bool,
  /** wrapper element, eg: 'Div' */
  wrapper: PropTypes.any
};
export default Target;
//# sourceMappingURL=Target.js.map